module.exports = __webpack_public_path__ + "assets/media/april.80013914.svg";